import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/app/middleware/auth.global.ts";
import lk_45pages_45global from "/app/middleware/lk-pages.global.ts";
import yandex_45auth_45redirect_45global from "/app/middleware/yandex-auth-redirect.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  lk_45pages_45global,
  yandex_45auth_45redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "admin-middleware": () => import("/app/middleware/adminMiddleware.ts"),
  email: () => import("/app/middleware/email.ts"),
  payment: () => import("/app/middleware/payment.ts"),
  "profile-auth": () => import("/app/middleware/profile-auth.ts"),
  "reset-password": () => import("/app/middleware/reset-password.ts"),
  yookassa: () => import("/app/middleware/yookassa.ts")
}